import React, { useState } from 'react'
import { Box, Flex } from 'styling/GlobalStyles'
import { PurchaseRequestCard } from './Components/PurchaseRequestCard'
import { useFilter } from 'hooks/useFilter'
import { useQuery } from '@tanstack/react-query'
import { getProcurementActionablePurchaseRequests } from 'api'
import { useNavigate } from 'react-router-dom'
import { toCsv } from 'utils/helpers'
import { Spinner } from 'components/Loading/Loading'
import { Pagination } from 'components/Table/Pagination'

type FilterValues = {
  departmentId: string | number | null
  departmentName: string | null
  clientStatus: string | null
}

export const Approvals = () => {
  const { values } = useFilter<FilterValues>({
    departmentId: null,
    departmentName: null,
    clientStatus: null,
  })
  const navigate = useNavigate()
  const { data, isLoading } = useQuery({
    queryKey: ['procurement-actionable-purchase-requests', values],
    queryFn: () =>
      getProcurementActionablePurchaseRequests({
        departmentIds: values.departmentId ? toCsv([values.departmentId]) : undefined,
        clientStatuses: values.clientStatus ? toCsv([values.clientStatus]) : undefined,
        page: values.page,
        limit: values.limit,
      }),
  })
  if (isLoading) return <Spinner fullscreen={false} />
  return (
    <>
      <Box height='60px' mb='16px' mt='16px'></Box>
      <Flex gap='1rem' column>
        {data?.data.map((item) => (
          <PurchaseRequestCard key={item.id} purchaseRequest={item} />
        ))}
        <Flex justend width='100%'>
          <Pagination itemCount={data?.totalCount || 0} limit={values.limit} />
        </Flex>
      </Flex>
    </>
  )
}
